import { Box, useTheme } from "@mui/material";
import { TOTAL_STEPPER_SEGMENTS } from "../../constants/steps";

interface OnboardingStepStepperProps {
  /** 0 = hidden, 1-6 = active segment */
  activeStep: number;
}

export const OnboardingStepStepper = ({
  activeStep,
}: OnboardingStepStepperProps): JSX.Element | null => {
  const theme = useTheme();

  if (activeStep === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        width: "100%",
        justifyContent: "center",
        marginBottom: "24px",
      }}
      role="progressbar"
      aria-valuenow={activeStep}
      aria-valuemin={1}
      aria-valuemax={TOTAL_STEPPER_SEGMENTS}
      aria-label={`Step ${Math.min(activeStep, TOTAL_STEPPER_SEGMENTS)} of ${TOTAL_STEPPER_SEGMENTS}`}
    >
      {Array.from({ length: TOTAL_STEPPER_SEGMENTS }, (_, i) => {
        const segmentIndex = i + 1;
        const isActiveOrCompleted = segmentIndex <= activeStep;

        return (
          <Box
            key={segmentIndex}
            sx={{
              height: "4px",
              flex: 1,
              maxWidth: "50.67px",
              borderRadius: "2px",
              backgroundColor: isActiveOrCompleted
                ? theme.palette.secondary["purple-tint"]
                : theme.palette.primitive.neutrals.neutral[700],
              transition: "background-color 0.3s ease",
            }}
          />
        );
      })}
    </Box>
  );
};
